import { useContext } from 'react';
import ApiContext from './ApiContext';

const useApi = () => useContext(ApiContext);

export default useApi;
